import { CheckCircle2, Download, Plus } from "lucide-react";
import libFloat from "../../../../util/libFloat";
import LibDateTime from "../../../../util/libDateTime";

export default function ResultadoRemessa({ resultado, onBaixarNovamente, onNovaRemessa }) {
	const boletos = resultado?.boletos || [];
	const total = boletos.reduce((soma, b) => soma + Number(b.valor || 0), 0);

	return (
		<div className="flex-1 flex flex-col min-h-0 gap-4">
			<div className="shrink-0 flex items-center gap-3 bg-emerald-50 border border-emerald-200 rounded-md px-4 py-3">
				<CheckCircle2 size={22} className="text-emerald-600 shrink-0" />
				<div className="flex-1">
					<p className="mb-0 font-semibold text-emerald-800">
						Remessa {resultado.numero_remessa} gerada
					</p>
					<p className="mb-0 text-sm text-emerald-700">
						{boletos.length} {boletos.length === 1 ? "boleto" : "boletos"} ·{" "}
						{libFloat.strToCurrency(total)} · arquivo {resultado.nome_arquivo}
					</p>
				</div>
			</div>

			<div className="flex-1 flex flex-col min-h-0 border rounded-md bg-white border-gray-300 overflow-hidden">
				<div className="flex-1 overflow-y-auto">
					<table className="table table-portal mb-0 w-full border-b">
						<thead className="color-table sticky top-0 z-10 shadow-sm">
							<tr>
								<th className="text-left font-semibold py-2 border-b">
									<span className="text-color-table">Cliente</span>
								</th>
								<th className="text-center font-semibold py-2 border-b w-24">
									<span className="text-color-table">Parcela</span>
								</th>
								<th className="text-center font-semibold py-2 border-b w-32">
									<span className="text-color-table">Vencimento</span>
								</th>
								<th className="text-right font-semibold py-2 border-b w-32">
									<span className="text-color-table">Valor</span>
								</th>
								<th className="text-left font-semibold py-2 border-b w-56">
									<span className="text-color-table">Nosso Número</span>
								</th>
							</tr>
						</thead>

						<tbody>
							{boletos.map((b) => (
								<tr key={b.id_conta_entrada} className="hover:bg-customBlue-primary/5">
									<td className="text-left align-middle font-medium py-2">{b.nome}</td>
									<td className="text-center align-middle text-gray-500 text-sm">
										{b.parcela}
									</td>
									<td className="text-center align-middle">
										{LibDateTime.parseDelphiLocal(b.vencimento, "dd/MM/yyyy")}
									</td>
									<td className="text-right align-middle text-emerald-600 font-semibold">
										{libFloat.strToCurrency(b.valor)}
									</td>
									{/* E este numero que volta no arquivo de retorno
									    do banco - por isso fica visivel aqui. */}
									<td className="text-left align-middle font-mono text-sm">
										{b.nosso_numero}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>

			<div className="shrink-0 flex items-center justify-between">
				<button
					className="btn btn-sm btn-outline-primary inline-flex items-center gap-2"
					onClick={onBaixarNovamente}
					title="Baixar o mesmo arquivo de novo"
				>
					<Download size={16} /> Baixar arquivo novamente
				</button>

				<button
					className="btn btn-primary inline-flex items-center gap-2"
					onClick={onNovaRemessa}
				>
					<Plus size={16} /> Nova remessa
				</button>
			</div>
		</div>
	);
}
